/* eslint-disable no-useless-escape */
import _ from "lodash";

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line no-useless-escape
const pwdRegex = /^(?=\P{Ll}*\p{Ll})(?=\P{Lu}*\p{Lu})(?=\P{N}*\p{N})(?=[\p{L}\p{N}]*[^\p{L}\p{N}])[\s\S]{8,}$/u;
const textRegex = /[a-zA-Z0-9\u00C0-\u017F\s_\.()']+$/;
const digitsRegex = /^[0-9]*$/;
const whitespaceRegex = /\s/g;
const addressRegex = /^[a-zA-Z\d\s/º,.`'çÇñÑ()^¨"´·-]|[à-ü]|[À-Ü]+$/;
const zipCodeRegex = /^[a-zA-Z0-9\d\s/().-]+$/;

const domainRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/m;
const phoneRegex = /\+[0-9]{1,15}$/;

const validZipCode = zipCode => {
  var re = zipCodeRegex;
  return re.test(zipCode);
};

const validPhone = phone => {
  var re = phoneRegex;
  return re.test(phone);
};

const validEmail = email => {
  var re = emailRegex;
  return re.test(email);
};

const validPassword = password => {
  var re = pwdRegex;
  return re.test(password);
};

const validText = text => {
  const re = textRegex;
  return re.test(text);
};

const validDigits = digits => {
  const re = digitsRegex;
  return re.test(Number(digits));
};

const validateWhitespace = text => {
  const re = whitespaceRegex;
  return !re.test(text);
};

const validateAddress = address => {
  const re = addressRegex;
  return re.test(address);
};

const validateDomain = domain => {
  const re = domainRegex;
  return re.test(domain);
};

const validMaxLength = (text, length) => {
  return text.length < length;
};

const validate = (fields, form) => {
  var result = {
    valid: true,
    errors: []
  };

  _.each(fields, group => {
    _.each(group.fields, field => {
      if (field.required && field.type === "datetime") {
        if (
          field.required &&
          (_.isEmpty(form[field.name + "_date"]) ||
            _.isEmpty(form[field.name + "_time"]))
        ) {
          result.valid = false;
          result.errors.push(field);
        }
      } else if (field.required && _.isEmpty(form[field.name])) {
        result.valid = false;
        result.errors.push(field);
      }
      if (field.type === "number") {
        if (field.min && field.min > form[field.name]) {
          result.valid = false;
          result.errors.push(field);
        }
      }
    });
  });

  return result;
};

export {
  validZipCode,
  validPhone,
  validEmail,
  validPassword,
  validText,
  validate,
  validDigits,
  validateWhitespace,
  validateAddress,
  validateDomain,
  validMaxLength,
  phoneRegex,
  emailRegex,
  pwdRegex,
  textRegex,
  digitsRegex,
  whitespaceRegex,
  addressRegex,
  domainRegex
};
